import { Injectable } from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  encPassword = 'dawnWebToolkits';
  preFix = '';
  constructor(
      private cookieService: CookieService
  ) { }

  setPreFix(prefix) {
    this.preFix = prefix;
  }

  setBusinessTypeItem(businessType) {
    this.setLocalItem('businessType', businessType)
  }

  getBusinessTypeItem(): number {
    const businessType = this.getLocalItem('businessType')
    if (businessType) {
      return parseInt(businessType, 10);
    } else {
      return -1;
    }
  }

  setUserId(id) {
    this.setItem(this.preFix + 'uid', id);
  }

  getUserId() {
    this.cookieService.get(this.preFix + 'uid');
  }

  getUserToken() {
    this.cookieService.get(this.preFix + 'token');
  }

  setItem(key, obj, expires?, path?, domain?, secure?, sameSite?) {
    this.cookieService.set(this.preFix + key, JSON.stringify(obj), expires, path, domain, secure, sameSite);
  }

  getItem(key) {
    if (this.cookieService.get(this.preFix + key)) {
      return JSON.parse(this.cookieService.get(this.preFix + key));
    } else {
      return undefined;
    }
  }

  setLocalItem(name, data) {
    localStorage.setItem(this.preFix + name, this.convertText(JSON.stringify(data), 'encrypt'));
  }

  getLocalItem(name) {
    const itemString = localStorage.getItem(this.preFix + name);
    if (itemString) {
      const depString = this.convertText(itemString, 'decrypt');
      return JSON.parse(depString);
    } else {
      return undefined;
    }
  }
  removeLocalItem(item) {
    localStorage.removeItem(this.preFix + item);
  }

  getUserRoles() {
    if (this.cookieService.get(this.preFix + 'userRoles')) {
      return JSON.parse(this.cookieService.get(this.preFix + 'userRoles'));
    } else {
      return undefined;
    }
  }

  getCurrentSysModule() {
    if (this.cookieService.get('currentSysModule')) {
      return this.cookieService.get('currentSysModule');
    } else {
      return undefined;
    }
  }

  setCurrentSysModule(currentSysModule) {
    this.setItem('currentSysModule', currentSysModule);
  }

  clearUserInfo() {
    this.cookieService.delete('token');
    this.cookieService.delete('refreshToken');
    this.cookieService.delete('tokenCheck');
    this.cookieService.delete('currentUser');
    this.cookieService.deleteAll;
    localStorage.removeItem('businessType');
    localStorage.clear;
    console.log('clearUserInfo1')
  }

  convertText(text: string, convertType: 'encrypt' | 'decrypt') {
    if (convertType === 'encrypt') {
      return CryptoJS.AES.encrypt(text.trim(), this.encPassword.trim()).toString();
    } else {
      return CryptoJS.AES.decrypt(text.trim(), this.encPassword.trim()).toString(CryptoJS.enc.Utf8);
    }
  }

}
